import { format, differenceInDays } from 'date-fns'

import Icon from '../Icons'
import { getCuttedString } from '../BuildingDashboard/BuildingEssentials/helpers'

import { makePeriods } from './AnalyticsConstants'

export const getStars = (starsValue, starsTotal = 5) => {
  const starPercentage = (starsValue / starsTotal).toFixed(2) * 100
  const starStyle = { width: '16px', height: '14px', display: 'inline-block' }

  return (
    <div className="star-value-wrapper">
      {starsValue ? <p className="star-value-text">{starsValue}</p> : null}
      <div className="stars-outer">
        {Array.from({ length: starsTotal }, (_, index) => index).map((_, index) => (
          <Icon key={index} styles={starStyle} viewBox="0 0 14 14" fill="#E1E0E0" icon="star" />
        ))}
        <div style={{ width: `${starPercentage}%` }} className="stars-inner">
          <Icon styles={starStyle} viewBox="0 0 14 14" icon="star" />
          <Icon styles={starStyle} viewBox="0 0 14 14" icon="star" />
          <Icon styles={starStyle} viewBox="0 0 14 14" icon="star" />
          <Icon styles={starStyle} viewBox="0 0 14 14" icon="star" />
          <Icon styles={starStyle} viewBox="0 0 14 14" icon="star" />
        </div>
      </div>
    </div>
  )
}

export const getDiffColor = (dataToCheck) => {
  if (!dataToCheck || ['0.00', 'NaN'].includes(dataToCheck.percentageDiff)) return
  return dataToCheck.percentageDiff[0] === '-' ? 'color-red' : 'color-green'
}

export const getDiffDirectionSymbol = (diff) => {
  if (!diff || ['0.00', 'NaN'].includes(diff)) return ''
  return diff[0] === '-' ? '▼' : '▲'
}

export const getDatesInText = (startEndDates, t) => {
  if (!startEndDates[1]) return ['', '']
  const periods = makePeriods(t)
  const startDate = format(startEndDates[0], 'MM/dd/yyyy')
  const endDate = format(startEndDates[1], 'MM/dd/yyyy')
  const datePeriods = periods.map((period) => {
    return [format(period.value.start, 'MM/dd/yyyy'), format(period.value.end, 'MM/dd/yyyy')]
  })

  let matchedPeriod

  datePeriods.forEach((period, i) => {
    if (period[0] === startDate && period[1] === endDate) {
      matchedPeriod = periods[i]
    }
  })

  if (!matchedPeriod) {
    return [
      `${startDate} - ${endDate}`,
      t('building-analytics:common.previousDays', {
        count: differenceInDays(startEndDates[1], startEndDates[0]),
      }),
    ]
  }
  return [
    matchedPeriod.title.toLowerCase(),
    t('building-analytics:common.previousDays', { count: matchedPeriod.days }),
  ]
}

export const getPercentageDiffText = (data) => {
  if (data && data.percentageDiff === '-') {
    return ''
  } else {
    return data && data.percentageDiff !== 'NaN'
      ? `${getDiffDirectionSymbol(data.percentageDiff)} ${
          data.percentageDiff === '-' ? '' : data.percentageDiff
        }%`
      : '00.00%'
  }
}

export const getAmenitiesChartData = (chartOptions, operationData) => {
  if (operationData && operationData.amenities) {
    const filteredAmenities = operationData.amenities
      .sort((amenity, nextAmenity) =>
        amenity[chartOptions.key].value > nextAmenity[chartOptions.key].value ? -1 : 1,
      )
      .filter((amenity) => amenity[chartOptions.key].value > 0)

    return {
      labels: filteredAmenities.map(({ name }) => getCuttedString(name, 15, 13)),
      datasets: [
        {
          label: chartOptions.label,
          backgroundColor: chartOptions.color,
          data: filteredAmenities.map((amenity) => amenity[chartOptions.key].value),
          diff: filteredAmenities.map((amenity) => amenity[chartOptions.key].percentageDiff),
        },
      ],
    }
  }
}
